module.exports = __webpack_public_path__ + "static/media/BGPG1@2x.baabf97e.png";